import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const ExpandMore = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"         ,} )
  })
)

export default ExpandMore
